export default __webpack_public_path__ + "static/media/HealthProtection.0c2390fb.svg";